var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10V6.66667C15.8333 4.31 15.8333 3.13083 15.1008 2.39917C14.3692 1.66583 13.19 1.66583 10.8333 1.66583H7.5C5.14333 1.66583 3.96417 1.66583 3.2325 2.39917C2.5 3.13083 2.5 4.31 2.5 6.66583V13.3325C2.5 15.6908 2.5 16.8692 3.2325 17.6008C3.96417 18.3333 5.14333 18.3333 7.5 18.3333H9.16667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 12.5H9.16634M5.83301 9.16666H12.4997M12.083 1.66666H6.24967C6.24967 2.84499 6.24967 3.43416 6.61634 3.79999C6.98134 4.16666 7.57051 4.16666 8.74967 4.16666H9.58301C10.7613 4.16666 11.3505 4.16666 11.7163 3.79999C12.083 3.43416 12.083 2.84499 12.083 1.66666ZM13.1138 18.0442L11.6663 18.3333L11.9555 16.8858C12.0138 16.5917 12.1588 16.3225 12.3713 16.1108L15.7588 12.7225C15.8293 12.6519 15.9129 12.596 16.005 12.5578C16.0971 12.5196 16.1958 12.4999 16.2955 12.4999C16.3952 12.4999 16.4939 12.5196 16.586 12.5578C16.6781 12.596 16.7617 12.6519 16.8322 12.7225L17.2772 13.1675C17.3477 13.2379 17.4037 13.3216 17.4419 13.4137C17.4801 13.5058 17.4997 13.6045 17.4997 13.7042C17.4997 13.8038 17.4801 13.9026 17.4419 13.9946C17.4037 14.0867 17.3477 14.1704 17.2772 14.2408L13.8897 17.6283C13.6785 17.8414 13.4082 17.9863 13.1138 18.0442Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/Task-icon.8082aabb1ef0b04adb71bf81da334898.svg";
export { ForwardRef as ReactComponent };